"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanReadableScore = humanReadableScore;
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.PSYCAP;
var psycap = ["Strongly Disagree", "Disagree", "Somewhat Disagree", "Somewhat Agree", "Agree", "Strongly Agree"];
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  extraText: "",
  type: "slider",
  options: psycap
};
var psycapQuestions = [// Psy-Cap Questions
{
  prompt: "I can think of many ways to reach my current goals at work."
}, {
  prompt: "The future holds a lot of good in store for me at work."
}, {
  prompt: "When I'm in a difficult situation at work I can usually find my " + "way out of it."
}, {
  prompt: "I can remain calm when facing difficulties at work because I can " + "rely on my coping abilities."
}];
var questions = (0, _utils.wrapBattery)(psycapQuestions, baseProps);
exports.questions = questions;

function humanReadableScore(psycapScore) {
  var summaryString = "Very Low";

  if (psycapScore >= 40) {
    summaryString = "Low";
  }

  if (psycapScore >= 80) {
    summaryString = "Average";
  }

  if (psycapScore >= 90) {
    summaryString = "High";
  }

  if (psycapScore >= 100) {
    summaryString = "Very High";
  }

  return summaryString;
}

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers) * 5);
  return {
    psycap: score,
    psycapHope: answers[0],
    psycapOptimism: answers[1],
    psycapResilience: answers[2],
    psycapSelfEfficacy: answers[3]
  };
}